import { GetLeaguePagePath } from "./utils"

const getters = {
	leagues: (state) => state.leagues.map((x) => x.data),
	seasons: (state) => {
		const seasons = state.leagues.reduce((seasons, league) => {
			let season = seasons.find((season) => season.season == league.data.season)

			if (!season) {
				season = {
					season: league.data.season,
					leagues: [],
				}

				seasons.push(season)
			}

			season.leagues.push(league.data)

			return seasons
		}, [])

		seasons.forEach((season) => season.leagues.sort((a, b) => a.name.localeCompare(b.name)))

		seasons.sort((a, b) => b.season.localeCompare(a.season))

		return seasons
	},
	activeLeagueKey: (state) => state.activeLeagueKey,
	activeTeamKey: (state) => state.activeTeamKey,
	activePageName: (state) => state.activePageName,
	activeLeague(state) {
		const league = state.leagues.find((x) => x.key == state.activeLeagueKey)

		return league ? league.data : null
	},
	activeTeam(state) {
		const league = state.leagues.find((x) => x.key == state.activeLeagueKey)
		const team = league && league.data.teams.find((x) => x.key == state.activeTeamKey)

		return team || null
	},
	activePage(state) {
		const key = GetLeaguePagePath(state)
		const page = state.pages.find((x) => x.key == key)

		return page ? page.data : null
	},
	activePageScheduleMatchup(state) {
		if ((state.activePageName == "team_dashboard" || state.activePageName == "team_schedule") && state.activePageScheduleWeekId) {
			const activePage = getters.activePage(state)

			if (activePage && activePage.schedule) {
				const activePageScheduleMatchup = activePage.schedule.find((x) => x.week_id == state.activePageScheduleWeekId)

				if (activePageScheduleMatchup) {
					return activePageScheduleMatchup
				}
			}
		}

		return null
	},
	activePageAlternateSchedule(state) {
		if (
			(state.activePageName == "team_dashboard" || state.activePageName == "team_alternate_schedules") &&
			state.activePageAlternateScheduleTeamKey
		) {
			const activePage = getters.activePage(state)

			if (activePage && activePage.alternate_schedules) {
				const activePageAlternateSchedule = activePage.alternate_schedules.find(
					(x) => x.team_key == state.activePageAlternateScheduleTeamKey
				)

				if (activePageAlternateSchedule) {
					return activePageAlternateSchedule
				}
			}
		}

		return null
	},
	activePagePlayoffsBracket(state) {
		return state.activePagePlayoffsBracket
	},
	activePagePlayoffsBracketRound(state) {
		return state.activePagePlayoffsBracketRound
	},
	activePageConsolationBracketRound(state) {
		return state.activePageConsolationBracketRound
	},
}

export default getters
